var _a;
import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { ApiTypes } from '../../types';
var sortByComparators = (_a = {},
    _a[ApiTypes.v1.GroupsSortBy.MEMBERS_COUNT] = function (a, b) {
        return b.memberCount - a.memberCount;
    },
    _a[ApiTypes.v1.GroupsSortBy.NAME] = function (a, b, locale) {
        return (a.details &&
            b.details &&
            a.details.title.localeCompare(b.details.title, locale, {
                sensitivity: 'base',
            }));
    },
    _a[ApiTypes.v1.GroupsSortBy.RECENT_ACTIVITY] = function (a, b) {
        return new Date(b.recentActivityDate).getTime() -
            new Date(a.recentActivityDate).getTime();
    },
    _a);
var GroupList = /** @class */ (function () {
    function GroupList(api) {
        var _this = this;
        this.api = api;
        this.groupNameFilter = function (group) {
            return group.details.title
                .toLowerCase()
                .includes(_this.groupNameQuery.toLowerCase());
        };
        this.groups = [];
        this.groupNameQuery = '';
    }
    GroupList.prototype.getState = function () {
        return {
            groups: this.getGroups(),
            groupNameQuery: this.getGroupNameQuery(),
            groupsSortBy: this.getGroupsSortBy(),
        };
    };
    GroupList.prototype.getGroupsSortBy = function () {
        return this.groupsSortBy;
    };
    GroupList.prototype.getGroupNameQuery = function () {
        return this.groupNameQuery;
    };
    GroupList.prototype.getGroups = function () {
        return this.getSortedGroups(this.getFilteredGroups());
    };
    GroupList.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroupList()];
                    case 1:
                        data = (_a.sent()).data;
                        this.groups = data.groups;
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.groups = [];
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GroupList.prototype.search = function (groupNameQuery) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // TODO: use real search api here
                    return [4 /*yield*/, Promise.resolve()];
                    case 1:
                        // TODO: use real search api here
                        _a.sent();
                        this.groupNameQuery = groupNameQuery;
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupList.prototype.sort = function (sortBy) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // TODO: use real search api here
                    return [4 /*yield*/, Promise.resolve()];
                    case 1:
                        // TODO: use real search api here
                        _a.sent();
                        this.groupsSortBy = sortBy;
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupList.prototype.getGroupById = function (groupId) {
        return this.groups.find(function (group) {
            return group.groupId === groupId || group.slug === groupId;
        });
    };
    GroupList.prototype.getSortedGroups = function (groups) {
        var compareFn = sortByComparators[this.groupsSortBy];
        return this.groupsSortBy && compareFn
            ? __spreadArray([], __read(groups)).sort(compareFn)
            : groups;
    };
    GroupList.prototype.getFilteredGroups = function () {
        return this.groupNameQuery
            ? this.groups.filter(this.groupNameFilter)
            : this.groups;
    };
    GroupList.prototype.listGroups = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listGroups(request)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.groups];
                    case 2:
                        e_2 = _a.sent();
                        console.log("GroupList listGroups FAIL");
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return GroupList;
}());
export { GroupList };
//# sourceMappingURL=GroupList.js.map